"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
// Icons
var CopyIcon_1 = __importDefault(require("relements/build/esm/ui/icons/CopyIcon"));
// Utils
var utils_1 = require("@src/utils");
var CopyCardWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    backgroundColor: props.theme.colors.grey.neon,
    borderRadius: props.theme.radii.sm,
    height: 95,
    padding: 15,
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: props.theme.colors.blue.pastel,
    },
}); });
var CopyCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, style = _a.style;
    return (react_1["default"].createElement(CopyCardWrapper, { flexDirection: "column", onClick: function () { return utils_1.copyToClipboard(subtitle, title); }, style: style },
        react_1["default"].createElement(box_1["default"], { padding: "0px", flexDirection: "column", alignItems: "flex-end" },
            react_1["default"].createElement(CopyIcon_1["default"], null)),
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0px", marginTop: "2px" },
            react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { paddingBottom: '2px' } }, title),
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "blue.haptik" }, subtitle))));
};
exports["default"] = CopyCard;
